import { mergeStyleSets } from "@fluentui/react";

const getVisibleIframeContainerStyles = (): React.CSSProperties => {
    return {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        zIndex: 9999999,
        justifyContent: 'center'
    };
};

export const getBotProtectionVerificationStyles = (showIframe: boolean) => {
    return mergeStyleSets({
        iframe: {
            border: 'none',
            width: 318,
            position: 'relative',
            top: 80
        },
        iframeContainer: showIframe ? getVisibleIframeContainerStyles() : {
            display: 'none',
        },
        dialogMain: {
            width: 400,
            height: 400
        }
    });
};